/*
	<input type="text" ng-model="mymodel.ssn" dp-valid-idnumber />
*/

'use strict';

angular.module('theme').directive('validSvSsn', function ($parse, SsnSvService) {
	return {
		require: 'ngModel',
		link: function(scope, element, attr, ngModelCtrl) {

			var validNumber = function (value) {
				// Only validate if there is anything to validate
				if (ngModelCtrl.$isEmpty(value)) {
					ngModelCtrl.$setValidity('ssn-sv', true);
					return undefined;
				}

				var service = SsnSvService(value);
				if (service.valid && service.ssn) {
					ngModelCtrl.$setValidity('ssn-sv', true);
					ngModelCtrl.$viewValue = service.formatted;
					ngModelCtrl.$render();
					return service.formatted;
				} else {
					ngModelCtrl.$setValidity('ssn-sv', false);
					return undefined;
				}
			};

			ngModelCtrl.$parsers.push(validNumber);
			ngModelCtrl.$formatters.push(validNumber);
		}
	};
});
